import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import PerfilAcesso from '../perfilAcesso/perfilAcesso';
import Usuario from '../usuario/usuario';
import UsuarioCliente from '../usuario/usuarioCliente';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Grupo from '../grupo/grupo';
import Motorista from '../motorista/motorista';
import MotoristaCnh from '../motorista/motoristaCnh';
import MotoristaCpf from '../motorista/motoristaCpf';
import PremioFaixa from '../premioFaixa/premioFaixa';
import OcorrenciaTipo from '../ocorrenciaTipo/ocorrenciaTipo';
import Ocorrencia from '../ocorrencia/ocorrencia';
import OcorrenciaAcao from '../ocorrenciaAcao/ocorrenciaAcao';
import OcorrenciaStatus from '../ocorrenciaStatus/ocorrenciaStatus';
import OcorrenciaDocumentoViagem from '../ocorrencia/ocorrenciaDocumentoViagem';
import Premiacao from '../premiacao/premiacao';
import Documento from '../documento/documento';
import Operacao from '../operacao/operacao';
import OperacaoPerfil from '../operacaoPerfil/operacaoPerfil';
import OperacaoDespesa from '../operacaoDespesa/operacaoDespesa';
import DocumentoViagem from '../documentoViagem/documentoViagem';
import DocumentoViagemComprovacao from '../documentoViagem/documentoViagemComprovacao';
import DocumentoViagemComprovada from '../documentoViagem/documentoViagemComprovada';
import DocumentoViagemFinalizada from '../documentoViagem/documentoViagemFinalizada';
import Unidade from '../unidade/unidade';
import Veiculo from '../veiculo/veiculo';
import UsuarioAcessorio from '../usuarioAcessorio/usuarioAcessorio';
import AcessorioTipo from '../acessorioTipo/acessorioTipo';
import AcessorioEvento from '../acessorioEvento/acessorioEvento';
import AcessorioSaida from '../acessorioSaida/acessorioSaida';
import AcessorioEntrada from '../acessorioEntrada/acessorioEntrada';
import AcessorioTransferencia from '../acessorioTransferencia/acessorioTransferencia';
import AcessorioInventario from '../acessorioInventario/acessorioInventario';
import ValePedagio from '../valePedagio/valePedagio';
import ValePedagioPeriodo from '../valePedagioPeriodo/valePedagioPeriodo';
import ValePedagioMotorista from '../valePedagioMotorista/valePedagioMotorista';
import ValePedagioSaldo from '../valePedagioMotorista/valePedagioSaldo';
import AcessorioSaldo from '../acessorioSaldo/acessorioSaldo';
import AcessorioHistorico from '../acessorioHistorico/acessorioHistorico';
import ValePedagioMotivo from '../valePedagioMotivo/valePedagioMotivo';
import ValePedagioSaldoPeriodo from '../valePedagioMotorista/valePedagioSaldoPeriodo';
import ValePedagioMotivoPeriodo from '../valePedagioMotorista/valePedagioMotivoPeriodo';
import DespesaTipo from '../despesaTipo/despesaTipo';
import Despesa from '../despesa/despesa';
import Reports from '../reports/reports';
import ReportsHistorico from '../reportsHistorico/reportsHistorico';
import ReportsConformidade from '../reportsConformidade/reportsConformidade';
import ReportsInconformidade from '../reportsInconformidade/reportsInconformidade';
import ReportsInconformidadeHistorico from '../reportsInconformidadeHistorico/reportsInconformidadeHistorico';
import ReportsIntegracaoGM from '../reportsIntegracaoGM/reportsIntegracaoGM';
import ReportsIntegracaoTetraPak from '../reportsIntegracaoTetraPak/reportsIntegracaoTetraPak';
import ReportsTrack from '../reportsTrack/reportsTrack';
import ComissaoTipo from '../comissaoTipo/comissaoTipo';
import ComissaoOperacao from '../comissaoOperacao/comissaoOperacao';
import ComissaoApuracao from '../comissaoApuracao/comissaoApuracao';
import ComprovanteEntrega from '../comprovanteEntrega/comprovanteEntrega';
import Braskem from '../braskem/braskem';
import LaudoControle from '../laudoControle/laudoControle';
import LaudoOcorrenciaTipo from '../laudoOcorrenciaTipo/laudoOcorrenciaTipo';
import ReportsIntegracaoVolvo from '../reportsIntegracaoVolvo/reportsIntegracaoVolvo';
import Etiqueta from '../etiqueta/etiqueta';
import IntegracaoLetsara from '../integracaoLetsara/integracaoLetsara';
import IntegracaoLetsaraLog from '../integracaoLetsara/integracaoLetsaraLog';
import AnaliseAcesso from '../analiseAcesso/analiseAcesso';
import OcorrenciaClasse from '../ocorrenciaClasse/ocorrenciaClasse';
import OcorrenciaGestao from '../ocorrencia/ocorrenciaGestao';
import OcorrenciaAnalise from '../ocorrencia/ocorrenciaAnalise';
import AppRastreio from '../appRastreio/appRastreio';
import LaudoOficina from '../laudoOficina/laudoOficina';
import MetaCombustivelModelo from '../metaCombustivelModelo/metaCombustivelModelo';
import MetaCombustivelModeloConsulta from '../metaCombustivelModelo/metaCombustivelModeloConsulta';
import MetaCombustivelModeloConsultaLog from '../metaCombustivelModelo/metaCombustivelModeloConsultaLog';
import MetaCombustivelTermoUso from '../metaCombustivelTermoUso/metaCombustivelTermoUso';

export default props => {

	if (!props.usuarioCarregado.acesso_cliente) {

		let administrador = props.usuarioCarregado && props.usuarioCarregado.id_perfil == 1; //Administrador
		let integracao = props.usuarioCarregado && (administrador || [140].includes(props.usuarioCarregado.id)); //Leonardo Zawatski Berton 
		
		return (
			<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
				<Switch>
					<Route exact path='/' component={Dashboard} />
					<Route path='/perfilAcesso' component={PerfilAcesso} />
					<Route path='/usuario' component={Usuario} />
					<Route path='/usuarioCliente' component={UsuarioCliente} />
					<Route path='/usuarioPerfil' component={UsuarioPerfil} />
					<Route path='/grupo' component={Grupo} />
					<Route path='/motorista' component={Motorista} />
					<Route path='/MotoristaCnh' component={MotoristaCnh} />
					<Route path='/MotoristaCpf' component={MotoristaCpf} />
					<Route path='/premioFaixa' component={PremioFaixa} />
					<Route path='/ocorrenciaTipo' component={OcorrenciaTipo} />
					<Route path='/ocorrenciaAcao' component={OcorrenciaAcao} />
					<Route path='/ocorrenciaClasse' component={OcorrenciaClasse} />
					<Route path='/ocorrenciaStatus' component={OcorrenciaStatus} />
					<Route path='/ocorrencia' component={Ocorrencia} />
					{((props.usuarioCarregado && props.usuarioCarregado.ocorrencia_gestao) || administrador) &&
					<Route path='/ocorrenciaGestao' component={OcorrenciaGestao} />}
					{((props.usuarioCarregado && props.usuarioCarregado.ocorrencia_gestao) || administrador) &&
					<Route path='/ocorrenciaAnalise' component={OcorrenciaAnalise} />}
					<Route path='/ocorrenciaDocumentoViagem' component={OcorrenciaDocumentoViagem} />
					<Route path='/premiacao' component={Premiacao} />
					<Route path='/documento' component={Documento} />
					<Route path='/operacao' component={Operacao} />
					<Route path='/operacaoPerfil' component={OperacaoPerfil} />
					<Route path='/operacaoDespesa' component={OperacaoDespesa} />
					<Route path='/documentoViagem' component={DocumentoViagem} />
					<Route path='/documentoViagemComprovacao' component={DocumentoViagemComprovacao} />
					<Route path='/documentoViagemComprovada' component={DocumentoViagemComprovada} />
					<Route path='/documentoViagemFinalizada' component={DocumentoViagemFinalizada} />
					
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_cadastro) &&
					<Route path='/unidade' component={Unidade} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_cadastro) &&
					<Route path='/veiculo' component={Veiculo} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_acesso) &&
					<Route path='/usuarioAcessorio' component={UsuarioAcessorio} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_cadastro) &&
					<Route path='/acessorioTipo' component={AcessorioTipo} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_cadastro) &&
					<Route path='/acessorioEvento' component={AcessorioEvento} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_saldo) &&
					<Route path='/acessorioSaldo' component={AcessorioSaldo} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_historico) &&
					<Route path='/acessorioHistorico' component={AcessorioHistorico} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_saida) &&
					<Route path='/acessorioSaida' component={AcessorioSaida} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_entrada) &&
					<Route path='/acessorioEntrada' component={AcessorioEntrada} />}
					{(props.usuarioCarregado && (props.usuarioCarregado.acessorio_transferencia_unidade || props.usuarioCarregado.acessorio_transferencia_veiculo)) &&
					<Route path='/acessorioTransferencia' component={AcessorioTransferencia} />}
					{(props.usuarioCarregado && props.usuarioCarregado.acessorio_inventario) &&
					<Route path='/acessorioInventario' component={AcessorioInventario} />}

					<Route path='/valePedagio' component={ValePedagio} />
					<Route path='/valePedagioMotivo' component={ValePedagioMotivo} />
					<Route path='/valePedagioPeriodo' component={ValePedagioPeriodo} />
					<Route path='/valePedagioMotorista' component={ValePedagioMotorista} />
					<Route path='/valePedagioSaldo' component={ValePedagioSaldo} />					
					<Route path='/valePedagioSaldoPeriodo' component={ValePedagioSaldoPeriodo} />
					<Route path='/valePedagioMotivoPeriodo' component={ValePedagioMotivoPeriodo} />
					<Route path='/despesaTipo' component={DespesaTipo} />
					<Route path='/despesa' component={Despesa} />
					{props.usuarioCarregado.reports &&
					<Route path='/reports' component={Reports} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsHistorico' component={ReportsHistorico} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsIntegracaoGM' component={ReportsIntegracaoGM} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsIntegracaoTetraPak' component={ReportsIntegracaoTetraPak} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsIntegracaoVolvo' component={ReportsIntegracaoVolvo} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsConformidade' component={ReportsConformidade} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsInconformidade' component={ReportsInconformidade} />}
					{props.usuarioCarregado.reports &&
					<Route path='/reportsInconformidadeHistorico' component={ReportsInconformidadeHistorico} />}
					{props.usuarioCarregado.track &&
					<Route path='/reportsTrack' component={ReportsTrack} />}
					<Route path='/comissaoTipo' component={ComissaoTipo} />
					<Route path='/comissaoOperacao' component={ComissaoOperacao} />
					<Route path='/comissaoApuracao' component={ComissaoApuracao} />
					<Route path='/comprovanteEntrega' component={ComprovanteEntrega} />
					<Route path='/braskem' component={Braskem} />
					<Route path='/laudoControle' component={LaudoControle} />
					<Route path='/laudoOficina' component={LaudoOficina} />
					<Route path='/laudoOcorrenciaTipo' component={LaudoOcorrenciaTipo} />
					{props.usuarioCarregado.acesso_etiqueta &&
					<Route path='/etiqueta' component={Etiqueta} />}

					{(administrador || (props.usuarioCarregado && props.usuarioCarregado.id == 28)) && //Gean Michel Gehm
					<Route path='/metaCombustivelModelo' component={MetaCombustivelModelo} />}
					
					{(administrador || (props.usuarioCarregado && props.usuarioCarregado.id == 28)) && //Gean Michel Gehm
					<Route path='/metaCombustivelModeloConsulta' component={MetaCombustivelModeloConsulta} />}

					{(administrador || (props.usuarioCarregado && props.usuarioCarregado.id == 28)) && //Gean Michel Gehm
					<Route path='/metaCombustivelModeloConsultaLog' component={MetaCombustivelModeloConsultaLog} />}

					{(administrador || (props.usuarioCarregado && props.usuarioCarregado.id == 28)) && //Gean Michel Gehm
					<Route path='/metaCombustivelTermoUso' component={MetaCombustivelTermoUso} />}
					
					{(props.usuarioCarregado && props.usuarioCarregado.acesso_usuario) &&
					<Route path='/integracaoLetsara' component={IntegracaoLetsara} />}
					{(administrador || integracao) &&
					<Route path='/integracaoLetsaraLog' component={IntegracaoLetsaraLog} />}

					{administrador &&
					<Route path='/analiseAcesso' component={AnaliseAcesso} />}

					{administrador &&
					<Route path='/appRastreio' component={AppRastreio} />}
					
					<Redirect from='*' to='/' />
				</Switch>
			</div>
		);
	} else {
		return (
			<div id='id-content-wrapper' className='content-wrapper' style={{ paddingBottom: 0 }} >
				<Switch>

					{(props.usuarioCarregado && props.usuarioCarregado.track) &&
					<Route exact path='/' component={ReportsTrack} />}

					{(props.usuarioCarregado && props.usuarioCarregado.reports) && 					
					<Route exact path={props.usuarioCarregado.track ? '/reports' : '/'} component={Reports} />}

					<Redirect from='*' to='/' />
				</Switch>
			</div>
		);
	}
};
